import {
  FETCH_ACTIVITY_LOGS_REQUEST,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  FETCH_ACTIVITY_LOGS_FAILURE,
} from '../actions/activityLogActions';

const initialState = {
  activityLogs: [],
  loading: false,
  error: null
};

const activityLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        activityLogs: action.payload,
        error: null
      };
    case FETCH_ACTIVITY_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default activityLogReducer;
